import type {
  ConfirmSubmissionMatchRequest,
  FormSubmission,
  FormSubmissionList,
  FormSubmissionQuery,
} from "@shared/types/form-submission";
import { api } from "./client";

function buildQueryString(query: FormSubmissionQuery): string {
  const params = new URLSearchParams();
  for (const [key, value] of Object.entries(query)) {
    if (value === undefined || value === null || value === "") continue;
    params.set(key, String(value));
  }
  const qs = params.toString();
  return qs.length === 0 ? "" : `?${qs}`;
}

export function listFormSubmissions(
  query: FormSubmissionQuery = {},
): Promise<FormSubmissionList> {
  return api.get<FormSubmissionList>(
    `/api/form-submissions${buildQueryString(query)}`,
  );
}

export function getFormSubmission(id: string): Promise<FormSubmission> {
  return api.get<FormSubmission>(
    `/api/form-submissions/${encodeURIComponent(id)}`,
  );
}

export function confirmFormSubmissionMatch(
  id: string,
  body: ConfirmSubmissionMatchRequest,
): Promise<FormSubmission> {
  return api.post<FormSubmission>(
    `/api/form-submissions/${encodeURIComponent(id)}/match`,
    body,
  );
}

export function clearFormSubmissionMatch(id: string): Promise<FormSubmission> {
  return api.deleteJson<FormSubmission>(
    `/api/form-submissions/${encodeURIComponent(id)}/match`,
  );
}

export function markFormSubmissionSpam(id: string): Promise<FormSubmission> {
  return api.post<FormSubmission>(
    `/api/form-submissions/${encodeURIComponent(id)}/mark-spam`,
    {},
  );
}

export function discardFormSubmission(id: string): Promise<FormSubmission> {
  return api.post<FormSubmission>(
    `/api/form-submissions/${encodeURIComponent(id)}/discard`,
    {},
  );
}

export function restoreFormSubmission(id: string): Promise<FormSubmission> {
  return api.post<FormSubmission>(
    `/api/form-submissions/${encodeURIComponent(id)}/restore`,
    {},
  );
}

export function generateFormSubmissionFieldUpdateProposal(
  id: string,
): Promise<FormSubmission> {
  return api.post<FormSubmission>(
    `/api/form-submissions/${encodeURIComponent(id)}/field-update-proposal/generate`,
    {},
  );
}

export function applyFormSubmissionFieldUpdateProposal(
  id: string,
): Promise<FormSubmission> {
  return api.post<FormSubmission>(
    `/api/form-submissions/${encodeURIComponent(id)}/field-update-proposal/apply`,
    {},
  );
}

export function approveFormSubmissionFieldUpdateProposalChange(
  id: string,
  changeId: string,
): Promise<FormSubmission> {
  return api.post<FormSubmission>(
    `/api/form-submissions/${encodeURIComponent(id)}/field-update-proposal/changes/${encodeURIComponent(changeId)}/approve`,
    {},
  );
}

export function rejectFormSubmissionFieldUpdateProposalChange(
  id: string,
  changeId: string,
): Promise<FormSubmission> {
  return api.post<FormSubmission>(
    `/api/form-submissions/${encodeURIComponent(id)}/field-update-proposal/changes/${encodeURIComponent(changeId)}/reject`,
    {},
  );
}

export function rejectFormSubmissionFieldUpdateProposal(
  id: string,
): Promise<FormSubmission> {
  return api.post<FormSubmission>(
    `/api/form-submissions/${encodeURIComponent(id)}/field-update-proposal/reject`,
    {},
  );
}
